import {Divider, Tooltip} from "antd";
import {Button, ButtonGroup} from "@mui/material";
import {ContrastSharp, ModeNight, WbSunny, WifiProtectedSetupSharp, FlashOnSharp} from "@mui/icons-material";
import React from "react";

const ColorControls = ({active, onChange, onColorChange}) => {
  return (
      <div>
          <ButtonGroup exclusive aria-label="text primary button group" size={'small'}>
              <Tooltip title={'Sample Dark Colors'}>
                  <Button variant={active==='dark'?'contained':''}
                          onClick={()=>onChange('dark')}
                          startIcon={<ModeNight />}
                  >
                      Dark
                  </Button>
              </Tooltip>
              <Tooltip title={'Vibrant Colors'}>
                  <Button variant={active==='bright'?'contained':''}
                          onClick={()=>onChange('bright')}
                          startIcon={<WbSunny />}
                  >
                      Bright
                  </Button>
              </Tooltip>
              <Tooltip title={'Include Dark & Light Colors'}>
                    <Button variant={active===null?'contained':''}
                            onClick={()=>onChange(null)}
                            startIcon={<ContrastSharp />}
                    >
                        Mixed
                  </Button>
              </Tooltip>
          </ButtonGroup>
      </div>
  );
};

export default ColorControls;